
import React, { useState, useEffect, useContext } from 'react'
import { Layout, Card, Table, Badge, Input, Typography, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../auth/AuthContext'
import { axiosForm } from '../../axiosInstances'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import DashboardLayout from '../dashboard/DashboardLayout'

dayjs.extend(utc)
dayjs.extend(timezone)

const { Content } = Layout
const { Title } = Typography

// Format date as "DD/MM/YYYY, HH:mm"
const formatUserFriendlyDate = (isoDate) =>
  isoDate ? dayjs(isoDate).tz(dayjs.tz.guess()).format('DD/MM/YYYY, HH:mm') : ''

const History = () => {
  const [rfqs, setRfqs] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchId, setSearchId] = useState("")
  const [filteredRfqs, setFilteredRfqs] = useState([])
  const navigate = useNavigate()
  const { user, token } = useContext(AuthContext)

  useEffect(() => {
    if (!token || !user) return
    setLoading(true)
    
    axiosForm.get(`/authentication/api/vendor/rfqs/?status=responded&vendor_name=${encodeURIComponent(user.vendor_name)}`)
      .then(response => {
        setRfqs(response.data.rfqs || [])
        setFilteredRfqs(response.data.rfqs || [])
        setLoading(false)
      })
      .catch(error => {
        console.error('Error fetching history RFQs:', error)
        setLoading(false)
      })
  }, [token, user])

  useEffect(() => {
    if (!searchId) {
      setFilteredRfqs(rfqs)
    } else {
      setFilteredRfqs(
        rfqs.filter(rfq =>
          rfq.rfq_number.toLowerCase().includes(searchId.toLowerCase())
        )
      )
    }
  }, [searchId, rfqs])

  const columns = [
    {
      title: 'Numéro RFQ',
      dataIndex: 'rfq_number',
      key: 'rfq_number',
      render: rfq_number => (
        <span style={{ fontSize: 18, fontWeight: 500 }}>{rfq_number}</span>
      )
    },
    {
      title: 'Articles',
      dataIndex: 'rfq_items_count',
      key: 'rfq_items_count',
      align: 'center',
      render: count => (
        <Badge count={count} style={{ backgroundColor: '#1890ff' }} showZero />
      ),
    },
    {
      title: 'Envoyé le',
      dataIndex: 'sent_date',
      key: 'sent_date',
      align: 'center',
      render: dateString => formatUserFriendlyDate(dateString),
    },
    {
      title: 'Échéance',
      dataIndex: 'due_date',
      key: 'due_date',
      align: 'center',
      render: dateString => formatUserFriendlyDate(dateString),
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'center',
      render: (_, rfq) => (
        <Button
          type="primary"
          size="small"
          onClick={() => navigate(`/rfq/${rfq.id}/history`)}
        >
          Voir le détail
        </Button>
      ),
    },
  ]

  return (
    <DashboardLayout selectedMenuKey="history">
      <Content style={{ margin: '40px 24px', overflow: 'auto' }}>
        <Card
          style={{ boxShadow: '0 2px 8px #f0f1f2', position: 'relative', maxWidth: 1100, margin: '0 auto' }}
          styles={{ body: { paddingTop: 40, paddingBottom: 24, paddingLeft: 24, paddingRight: 24 } }}
        >
          <Title level={4} style={{ marginBottom: 16, fontWeight: 700 }}>
            Historique RFQs soumis <Badge count={filteredRfqs.length} style={{ background: '#1890ff' }} />
          </Title>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16, gap: 12 }}>
            <Input
              placeholder="Numéro RFQ"
              prefix={<SearchOutlined />}
              value={searchId}
              allowClear
              onChange={e => setSearchId(e.target.value)}
              style={{ width: 300 }}
            />
          </div>
          <Table
            columns={columns}
            dataSource={filteredRfqs}
            rowKey="id"
            loading={loading}
            pagination={false}
            locale={{
              emptyText: <span className="text-muted">Aucun RFQ soumis</span>
            }}
          />
        </Card>
      </Content>
    </DashboardLayout>
  )
}

export default History
